import React, { FC } from 'react';
import { Popup } from 'devextreme-react/popup';

//devextreem
import Button from 'devextreme-react/button';

import { useDeleteRoleMutation } from 'bus/role/role';
import { isSuccess } from 'utils/responseStatus';

type DetailModalRoleProps = {
    id: number | null;
    visible: boolean;
    changeVisible: (visible: boolean) => void
    refresh: () => void
}

const DetailModalRole: FC<DetailModalRoleProps> = (props) => {
    const [deleteRole, { isLoading }] = useDeleteRoleMutation();

    const handleSubmit = async (e: any) => {
        e.preventDefault && e.preventDefault()
        await deleteRole({ id: props.id! }).then((resp: any) => {
            if (isSuccess(resp)) {
                props.refresh();
                props.changeVisible(false);
            }
        });
    }

    return (
        <div>
            <Popup
                visible={props.visible}
                onHiding={() => props.changeVisible(false)}
                dragEnabled={true}
                closeOnOutsideClick={false}
                showTitle={true}
                title="Подтвердите действие"
                width={400}
                height={160}
            >
                <div className="modal-block">
                    <form onSubmit={handleSubmit}>
                        <div className="modal-block__content">
                            Вы действительно хотите удалить роль?

                        </div>

                        <div className="modal-block__footer">
                            <Button
                                width={120}
                                text='Отмена'
                                type="normal"
                                onClick={() => props.changeVisible(false)}
                                stylingMode="text"
                            />
                            <Button
                                width={120}
                                text="Удалить"
                                type="danger"
                                stylingMode="text"
                                useSubmitBehavior={true}
                                onClick={() => handleSubmit}
                                disabled={isLoading}
                            />
                        </div>
                    </form>
                </div>
            </Popup>
        </div>
    )
}

export default DetailModalRole;